var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCollectorIcon = function SvgCollectorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.477 0H0v8.477A8.477 8.477 0 1 0 8.477 0Zm4.217 9.176-2.331 2.331-1.017 1a1.241 1.241 0 0 1-1.759 0L4.26 9.18a2.984 2.984 0 0 1 4.111-4.323l.127.127a2.97 2.97 0 1 1 4.2 4.2Z"
  })));
};
export default SvgCollectorIcon;